export default __webpack_public_path__ + "static/media/RASERE WHITE.3eb10e6b.png";